import * as yup from 'yup';
import { NICKNAME_INVALID } from '../../../constants/field-error-messages';
import { NICKNAME_REGEX } from '../../../constants/regex';

export const validationSchema = yup.object().shape({
  cardNickName: yup
    .string()
    .matches(NICKNAME_REGEX, { message: NICKNAME_INVALID.message }),
});
